import { IconName } from "PFTheme/graphics/icons";

export const GRID_COLUMNS_COUNT = 4;

export const DEFAULT_ICONS: IconName[] = [
  "non-demand",
  "learning",
  "palm-tree",
  "person-minus",
  "profiles",
  "baby",
  "house-laptop",
  "car",
  "wine-glass",
  "plane",
  "flower-spa",
  "bell",
  "error",
  "core",
  "heart",
  "ghost",
  "phone",
  "snooze",
  "face-smile",
  "house-user",
  "head-heart",
  "book",
  "pen",
  "bug"
];

export const getOptionId = (dropdownId: string, optionId: string) => `${dropdownId}-${optionId}`;
